export class Region {
  name: string;
  statusPageUrl: string;
  statusDescription: string;
  index: number;
}
